import { useStrings } from "@1js/localization-components";
import { Column, Row } from "@1js/pl-card-components";
import {
  Link,
  Text,
  makeStyles,
  shorthands,
  tokens,
} from "@fluentui/react-components";
import parse from "html-react-parser";
import * as React from "react";
import { useFlightContext } from "../../hooks/useFlightContext";
import { TeamName } from "../../types";
import { sendDiagnosticEvent } from "../../utils/Telemetry";
import { LogCategory, LogType } from "../../utils/Telemetry/events";
import { getPromptGalleryAppParameters, navigateToApp } from "../../utils/url";
import { MainTitleTeamTab } from "../PromptHeading/PromptHeading.web.string";
import {
  SubHeading,
  SubHeading2,
  SubHeadingLink,
} from "./MosSubheading.web.string";

const useStyles = makeStyles({
  container: {
    zIndex: 0,
    marginTop: "48px",
    ...shorthands.gap("8px"),
  },

  containerMetaOs: {
    zIndex: 0,
    marginTop: "5px",
    ...shorthands.gap("8px"),
  },

  subHeading: {
    color: tokens.colorNeutralForeground3,
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: tokens.fontWeightRegular,
    lineHeight: "22px",
    maxWidth: "600px",

    "@media (max-width: 540px)": {
      width: "210px",
    },
  },
  headingContainerv2: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    textAlign: "left",
    marginTop: "24px",
    marginBottom: "48px",
  },
});

/*
Navigates to the Copilot Prompt Gallery main MOS app
*/
const navigateToPromtGalleryApp = () => {
  sendDiagnosticEvent(
    LogType.Informational,
    `navigate to app from teams channel`,
    LogCategory.NAVIGATETOAPP
  );
  navigateToApp(getPromptGalleryAppParameters());
};

export const MosSubHeading: React.FC = () => {
  const styles = useStyles();
  const localizations = useStrings({
    SubHeading,
    SubHeading2,
    SubHeadingLink,
    MainTitleTeamTab,
  });

  const { isFlightActive } = useFlightContext();
  const isMetaOsV2 = isFlightActive("isMosAppV2DesignEnabled");
  const teamTabName = localStorage.getItem(TeamName);

  const getHeadingClass = () => {
    const headingStyle = styles.subHeading;
    return headingStyle;
  };

  if (isMetaOsV2) {
    return (
      <div className={styles.headingContainerv2}>
        <div className={styles.subHeading}>
          <h1>
            {parse(localizations.MainTitleTeamTab() + ": " + teamTabName)}
          </h1>
          <div className={getHeadingClass()}>
            {" "}
            {parse(localizations.SubHeading())}{" "}
          </div>
          {parse(localizations.SubHeading2())}{" "}
          <Link
            style={{ whiteSpace: "nowrap", textAlign: "center" }}
            onClick={navigateToPromtGalleryApp}
            id={"link-to-app-from-teams-channel"}
          >
            {parse(localizations.SubHeadingLink())}
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.headingContainerv2}>
      <Row>
        <Column size={12}>
          <Text align="start" className={getHeadingClass()}>
            <h1>
              {parse(localizations.MainTitleTeamTab() + ": " + teamTabName)}
            </h1>
            {parse(localizations.SubHeading())}
          </Text>
        </Column>
      </Row>

      <Row>
        <Column size={12}>
          <Text as="h2" align="center" className={getHeadingClass()}>
            {parse(localizations.SubHeading2())}{" "}
            <Link
              style={{ whiteSpace: "nowrap", textAlign: "center" }}
              onClick={navigateToPromtGalleryApp}
              id={"link-to-app-from-teams-channel"}
            >
              {parse(localizations.SubHeadingLink())}
            </Link>
            .
          </Text>
        </Column>
      </Row>
    </div>
  );
};
